import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import AsideTag from "../AsideTags/AsideTag/AsideTag";
import stl from "./SubFilterOpenButton.module.css";
function SubFilterOpenButton(_ref) {
  var name = _ref.name,
    onClick = _ref.onClick,
    count = _ref.count,
    isLoading = _ref.isLoading,
    disabled = _ref.disabled,
    isRange = _ref.isRange,
    handleDeleteFilters = _ref.handleDeleteFilters,
    option = _ref.option,
    filterField = _ref.filterField;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: filterField ? "filter-btn-".concat(filterField) : undefined,
    className: "".concat(stl.container, " ").concat(isLoading ? stl.isLoading : "", " ").concat(disabled ? stl.disabled : ""),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("strong", null, name), count && !isRange && /*#__PURE__*/React.createElement("span", {
    className: stl.seletedItems
  }, count), count && isRange && /*#__PURE__*/React.createElement(AsideTag, {
    onClick: function onClick(e) {
      e.stopPropagation();
      handleDeleteFilters(option);
    },
    name: "".concat(option.range_values.from, " - ").concat(option.range_values.to, " ").concat(option.range_values.unit),
    className: stl.rangeTag,
    textellipsis: true
  }), isLoading ? /*#__PURE__*/React.createElement("div", {
    className: stl.fixedLoaderContainer
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.loaderContainer,
    src: CDN_LINK + "/assets/images/FilterLoader.svg",
    alt: "loading"
  })) : !disabled ? /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrAcc.svg",
    alt: "arrow",
    width: "12px",
    height: "7px"
  }) : null));
}
export default SubFilterOpenButton;